import React, { useContext, useEffect } from "react";
import "./NewsletterModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";
import OwLabel from "../../shared/OwLabel/OwLabel";
import styled from "styled-components";
import IUserReleaseNewsletterDTO from "../../../models/DTO/IUserReleaseNewsletterDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import ILoadUserDTO from "../../../models/DTO/ILoadUserDTO";

type Props = {
    closeModalFn: (reload?: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    refreshListener: () => void;
};

export const NewsletterModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    useEffect(() => {
        props.socket.on(EndpointsEnum.UserOnReleaseNewsletter, onReleaseNewsLetter);
        props.socket.on(EndpointsEnum.AppOnLoadUser, onLoadUser);

        return () => {
            props.socket.removeListener(EndpointsEnum.UserOnReleaseNewsletter, onReleaseNewsLetter);
            props.socket.removeListener(EndpointsEnum.AppOnLoadUser, onLoadUser);
        };
    }, []);

    const closeModal = () => {
        props.closeModalFn(false);
    };

    const submitModal = (sendNewsletter: boolean) => {
        const payload: IUserReleaseNewsletterDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            sendNewsletter,
        };

        props.socket.emit(EndpointsEnum.UserReleaseNewsletter, payload);
    };

    const onReleaseNewsLetter = () => {
        const notification: INotification = {
            message: "completed_newsletter_question",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);

        loadUser();
    };

    const loadUser = () => {
        const payload: ILoadUserDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
        };

        props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    const onLoadUser = () => {
        props.closeModalFn(true);
    };

    return (
        <NewsletterContainer className={"NewsletterModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-typewriter"} title={"release_newsletter"} tag={"h3"} />
                    {/*<div>*/}
                    {/*    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />*/}
                    {/*</div>*/}
                </div>
            </div>

            <div>
                <p>
                    <OwLabel title={"newsletter_details"} />
                    <ul>
                        <li>
                            <OwLabel title={"new_features"} />
                        </li>
                        <li>
                            <OwLabel title={"bug_fixes"} />
                        </li>
                        <li>
                            <OwLabel title={"enhancements"} />
                        </li>
                        <li>
                            <OwLabel title={"new_products"} />
                        </li>
                    </ul>
                </p>

                <div>
                    <OwButton title={"yes"} fn={() => submitModal(true)} />
                    <OwButton title={"no"} className={"ms-2 btn-danger"} fn={() => submitModal(false)} />
                </div>
            </div>
        </NewsletterContainer>
    );
};

const NewsletterContainer = styled.div`
    padding-left: 30% !important;
`;
